<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">
        매체 수정
        <span class="attention-coment-1">
          <v-icon>mdi-alert-circle</v-icon>
          매체 수정 후 저장버튼을 클릭하여야 수정된 내용이 적용됩니다.
        </span>
      </h2>

      <ul class="tab-type-1">
        <li>
          <router-link :to="{ name: 'mediaModify' }" class="active"
            >매체 기본정보</router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'mediaInventories' }"
            >지면 관리</router-link
          >
        </li>
      </ul>

      <v-form ref="form">
        <!-- mediaLogo -->
        <h3 class="title-type-3">
          매체 로고 이미지
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>

        <div class="form-group relative white rounded pa-6 mb-8">
          <div class="file-upload-box-1">
            <div class="file-thumb">
              <img v-if="file.thumb" :src="file.thumb" alt="" />
              <v-icon v-else>mdi-image-outline</v-icon>
            </div>
            <p class="form-coment-1 mt-3">
              <v-icon>mdi-alert-circle-outline</v-icon>
              40x40pix / *.png
            </p>
            <p class="file-name" v-if="file.name">
              {{ file.name }}
            </p>
            <div class="file-wrap">
              <v-btn
                large
                depressed
                max-height="32px"
                color="#fecd06"
                class="button-type-1"
                type="file"
              >
                파일 업로드
              </v-btn>
              <input type="file" @change="onFileChange" accept="image/png" />
            </div>
          </div>
        </div>

        <!-- //mediaLogo -->

        <!-- mediaName -->
        <h3 class="title-type-3">
          매체명
          <p class="form-coment-1 ml-2 mt-1">
            <v-icon>mdi-alert-circle-outline</v-icon>
            매체명은 변경이 불가합니다.
          </p>
        </h3>
        <div class="relative white rounded pa-6 mb-8 text-md-body-1">
          {{ mediaName }}
        </div>
        <!--// mediaName -->

        <!-- form-wrap-->
        <div class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              매체 타입
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-select
                :items="searchSel"
                label="선택"
                v-model="searchSelChoice"
                @change="onChangeOption"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
              ></v-select>
            </div>
          </div>

          <div class="form-group mb-8">
            <h3 class="title-type-3">
              매체 상태
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-select
                :items="searchSel2"
                label="선택"
                v-model="searchSelChoice2"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
              ></v-select>
            </div>
          </div>
        </div>
        <!-- //form-wrap -->

        <!-- options -->
        <h3 class="title-type-3">
          지면 옵션 선택
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="white rounded pa-6">
          <p class="text-type-1">
            등록할 매체의 지면들이 사용할 지면 특성만 선택하면 등록을 간편하게
            하실 수 있습니다.
          </p>
          <p class="form-coment-1 mt-2">
            <v-icon>mdi-alert-circle-outline</v-icon>
            지면 옵션 추가는 소스 개발 후 적용 가능합니다.
          </p>
          <div class="mt-6">
            <v-btn
              depressed
              max-height="32px"
              :color="
                this.options.length <= this.optionChx.length
                  ? '#eee'
                  : '#fecd06'
              "
              class="button-type-1"
              @click.prevent="onCheckAll"
            >
              {{
                this.options.length <= this.optionChx.length
                  ? '선택 해제'
                  : '전체 선택'
              }}
            </v-btn>
          </div>
          <ul class="chx-list-type-1 five border-top padding-right-type-1 mt-6">
            <li v-for="(option, index) in options" :key="index">
              <v-checkbox
                v-model="optionChx"
                :value="option.id"
                color="#fecd00"
                off-icon="mdi-checkbox-blank"
                class="checkbox-type-1"
                hide-details
              >
                <template v-slot:label>
                  {{ option.name }}
                  <v-tooltip right content-class="tooltip-custom-1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ico-help-2 ml-1" v-bind="attrs" v-on="on"
                        >mdi-help-circle-outline</v-icon
                      >
                    </template>
                    <span>{{ option.note }}</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </li>
          </ul>
        </div>
        <!-- //options -->

        <div class="d-flex justify-end mt-10">
          <v-btn
            large
            depressed
            min-width="104px"
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.stop="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            min-width="104px"
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-4"
            :disabled="Object.keys(this.optionChx).length < 1"
            @click.prevent="registerMedias"
          >
            저장
          </v-btn>
        </div>
      </v-form>
    </div>

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { detailMedia, modifylMedia, listMediaInventories } from '@/api/media';
import { optionsList } from '@/api/options';
import { constantMediaType } from '@/utils/constant';
import { uploadWithNewPermission } from '@/api/etc';

import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  components: { SystemAlert },
  data: () => ({
    file: {
      img: null,
      name: null,
      thumb: null,
    },
    mediaName: '',
    searchSel: ['APP'],
    searchSelChoice: 'APP',
    searchSel2: ['운영중', '개발중'],
    searchSelChoice2: '',
    optionsDefault: [],
    optionsApp: [],
    options: [],
    optionChx: [],
    inventoryState: false,
    resultType: '',
    logResult: '',
    showSystemAlert: false,
  }),
  methods: {
    async getOptions() {
      try {
        const { data } = await optionsList();
        const lists = data.list;
        this.optionsDefault = lists;
        const optionsApp = [];
        lists.map(list => {
          /**
           * 기존 옵션 이름으로 체크하던 조건 변경
           * list.name === '동영상 광고' || list.name === '이미지 광고'
           */
          if (list.key === 'video' || list.key === 'image')
            optionsApp.push(list);
        });
        this.optionsApp = optionsApp;
        this.options = optionsApp;
        this.getMedias();
      } catch (error) {
        console.log(error.response);
        bus.$emit('end:spinner');
      }
    },
    async getMedias() {
      try {
        const id = this.$route.params.id;
        const { data } = await detailMedia(id);
        const row = data.row;
        const otps = [];

        this.mediaName = row.name;
        this.file.thumb = row.logo;

        await this.onTypeCheck(row.type);
        await this.onChangeOption();

        row.options.forEach(opt => {
          otps.push(opt.id);
        });
        this.optionChx = otps;

        row.is_valid === 'N'
          ? (this.searchSelChoice2 = '개발중')
          : (this.searchSelChoice2 = '운영중');

        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error.response);
        bus.$emit('end:spinner');
      }
    },
    async getListInventory() {
      try {
        const id = this.$route.params.id;
        const { data } = await listMediaInventories(id);
        const getListInventory = data.list;

        this.inventoryState = getListInventory.length > 0 ? true : false;
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },
    onTypeCheck(type) {
      this.searchSelChoice = constantMediaType[type];
    },
    onChangeOption() {
      this.searchSelChoice === 'APP'
        ? (this.options = this.optionsApp)
        : (this.options = this.optionsDefault);

      this.optionChx = [];
      //console.log('onChangeOption');
    },
    onCheckAll() {
      this.options.length <= this.optionChx.length
        ? (this.optionChx = [])
        : this.options.forEach(opt => {
            this.optionChx.push(opt.id);
          });
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.file.name = file.name;
      this.file.thumb = URL.createObjectURL(file);
      this.file.img = file;
    },
    async registerMedias() {
      bus.$emit('start:spinner');
      try {
        const id = this.$route.params.id;

        const options = this.optionChx.reduce((previous, current) => {
          previous.push({ id: current });
          return previous;
        }, []);

        const type = this.searchSelChoice === 'APP' ? 'app' : 't';
        const is_valid = this.searchSelChoice2 === '개발중' ? 'N' : 'Y';

        if (is_valid === 'Y' && !this.inventoryState) {
          this.showSystemAlert = true;
          this.logResult = '지면 등록 후 매체 상태를 변경 저장 할 수 있습니다.';
          bus.$emit('end:spinner');
          return;
        }

        // 새 로고를 골랐으면 저장 직전에 업로드하고, 실패하면 저장하지 않는다
        let logo = null;
        if (this.file.img) {
          try {
            logo = await uploadWithNewPermission('png', this.file.img);
          } catch (error) {
            console.log(error.response);
            bus.$emit('end:spinner');
            this.showSystemAlert = true;
            this.logResult =
              '이미지 업로드에 실패하였습니다. 다시 시도해주세요.';
            return;
          }
        }

        const resultData = () => {
          const result = {
            name: this.mediaName.trim(),
            type: type,
            is_valid: is_valid,
            options: options,
          };
          if (logo) result.logo = logo;
          return result;
        };

        const { data } = await modifylMedia(id, resultData());

        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '변경사항이 저장되었습니다.';
        }
      } catch (error) {
        bus.$emit('end:spinner');
        const { data } = error.response;
        this.resultType = data.result;
        this.showSystemAlert = true;
        if (data.result === 'DuplicatedEntry') {
          this.logResult = '이미 사용중인 매체명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        } else if (data.result === 'DoesNotHavePermission') {
          this.logResult = `접속하신 계정은 관리 권한이 없습니다.<br/> VX사업부에 문의 부탁드립니다`;
        } else {
          console.log(error.response);
        }
      }
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.$router.push({ name: 'media' }).catch(() => {});
      }
    },
    cancel() {
      this.$refs.form.reset();
      this.$router.push({ name: 'media' }).catch(() => {});
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.getOptions();
    this.getListInventory();
  },
};
</script>
